import React from 'react';
import { UserOutlined } from '@ant-design/icons';

import type { XoePatientChipProps } from '../../types/xoe/XoeUiTypes';

const XoePatientChip: React.FC<XoePatientChipProps> = ({ name, 'data-testid': testId }) => (
	<span className="mg-xoe-patient-chip" data-testid={testId} title={name}>
		<UserOutlined />
		<span className="mg-xoe-patient-chip-name">{name}</span>
	</span>
);

export default XoePatientChip;
